import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import {
  Estimate,
  VendorOrder,
} from '../../../../../../shared/models/vendor-order.model';
import { QuoteCardComponent } from '../quote-card/quote-card.component';

@Component({
  selector: 'app-vendor-rejections-accordion',
  standalone: true,
  imports: [QuoteCardComponent],
  templateUrl: './vendor-rejections-accordion.component.html',
  styleUrl: './vendor-rejections-accordion.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VendorRejectionsAccordionComponent {
  readonly order = input.required<VendorOrder>();
  readonly rejectedEstimates = input.required<Estimate[]>();
  readonly rejectedVendorCount = input.required<number>();
}
